import React, { useEffect } from 'react';
import './ThinkFinancePage.css';
import { useNavigate } from 'react-router-dom';
// import ThinkFinanceLogo from '../assets/ThinkFinance-Logo-removebg-preview.png';
import modulepic1 from '../assets/Finance - Executive Summary.png';
import modulepic2 from '../assets/modulepic2.png';
import modulepic3 from '../assets/ThinkFinance - PNL Transactions.png';
import modulepic4 from '../assets/Predictive Analytics.png';
// import Square from '../assets/blue-bg.png';
import ThinkFinanceLogo from '../assets/ThinkFinance-Logo-removebg-preview.png'; // Adjust the path as necessary

const ThinkFinancePage = () => {
  const navigate = useNavigate();
const handleNavigate = (path) => {
  navigate(path);
  // Scroll to top after navigation
  window.scrollTo(0, 0);
};
  //State for active module
  const [activeModuleIndex, setActiveModuleIndex] = React.useState(0);
  // Array of module data with images
  const modules = [
    {
      title: "Financial Dashboard Highlights",
      description: "A snapshot of correlated financial metrics provides insights into the organisation, enabling senior executives to leverage these reports for strategic decision-making that enhances overall company performance.",
      image: modulepic1
    },
    {
      title: "Design For Action",
      description: "Advanced analytics algorithms process financial data to identify patterns, predict employee behavior, and optimize workforce planning with machine learning technology.",
      image: modulepic2
    },
    {
      title: "Drilldown For Transactions",
      description: "Explore detailed employee metrics with interactive visualization tools that allow users to navigate from high-level summaries to granular details for comprehensive analysis.",
      image: modulepic3
    },
    {
      title: "Predictive Analytics",
      description: "Harness the power of AI to forecast your business performance with P&L forecasting and comparisons between Actual, Budget and Forecast.",
      image: modulepic4
    }
  ];
  
  // Auto-rotate modules every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveModuleIndex((prevIndex) => (prevIndex + 1) % modules.length);
    }, 50000);
    return () => clearInterval(interval);
  }, [modules.length]);

  return (
    <div className="think-finance-page">   
      {/* Hero Section */}
      <section className="tf-hero-section">
        <div className="tf-hero-content">
          <h1 className="tf-hero-title">
            <img
                className="tf-hero-logo"
                src={ThinkFinanceLogo}
                alt="ThinkFinance Logo"
                />
            
          </h1>
          <h2 className="tf-hero-subtitle">Stop missing out on actionable financial analytics</h2>
          <p className="tf-hero-description">
            Finance is the lifeblood of every business. In today's fast-paced, data-driven world, waiting for reports can be costly. ThinkFinance bridges the gap between perception and reality, empowering businesses to track performance and implement strategies quickly. Lead your company to new heights!
          </p>
        </div>
        <div className="tf-square-image-frame">
          {/* <img src={Square} alt="Square San" /> */}
        </div>
        <div className="tf-hero-image-container">
          {/* <div className="tf-image-frame">
            <img src={ThinkFinanceLogo} alt="TK" />
          </div> */}
        </div>
        <div className="tf-accent-shape-top-right"></div>
      </section>

      {/* Interactive Modules Section */}
      <section className="tf-modules-section">
        <div className="tf-section-divider">
          {/* <h2 className="tf-section-title-thinkfinance">Available Modules</h2> */}
        </div>
        
        <div className="tf-modules-container">
          {/*Interactive Module List*/}
          <div className="tf-module-list">
            {modules.map((module, index) => (
              <div
                key={index}
                className={`tf-module-item ${activeModuleIndex === index ? 'active' : ''}`}
                onClick={() => setActiveModuleIndex(index)}
              >
                <div className="tf-module-header" style={{ display: 'flex', alignItems: 'flex-start' }}>
                  {/* Blue indicator stick */}
                  <div
                   className="blue-indicator"
                   style={{
                    width: '4px',
                    height: '30px',
                    marginRight: '15px',
                    marginTop: '5px',
                    borderRadius: '10px',
                    backgroundColor: activeModuleIndex === index ? '#3B82f6' : '#e0e0e0',
                    transition: 'background-color 0.5s ease'
                   }}
                   ></div>
                  {/* Module Title */}
                  <h3 style={{
                    color: activeModuleIndex === index ? '#000' : '#666',
                    transition: 'color 0.3s ease'
                  }}>
                    {module.title}
                  </h3>
                </div>
                {/* Module Description (only visible for active module) */}
                {activeModuleIndex === index && (
                  <div
                    className="tf-module-content"
                    style={{
                      paddingLeft: '19px',
                      marginTop: '10px',
                      maxHeight: '100px',
                      overflow: 'hidden',
                      transition: 'max-height 0.5s ease'
                    }}
                    >
                      <p style={{ fontSize: '16px', lineHeight:'1.6',color: '#555' }}>
                        {module.description}
                      </p>
                    </div>
                  )}
              </div>
            ))}
          </div>

          {/* Dynamic Module Image */}
          <div className="tf-module-image-display">
            <div className="tf-dynamic-module-image-container">
              <img 
                src={modules[activeModuleIndex].image} 
                alt={modules[activeModuleIndex].title}
                className="tf-module-display-image"
              />
              <div className="tf-image-overlay">
                <div className="tf-image-title">
                  {modules[activeModuleIndex].title}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className= "tf-demo-btn-container">
          <button className="tf-demo-btn" onClick={() => handleNavigate('/contactus')}>Request For Demo </button> 
        </div>
        <div className="tf-accent-shape-bottom-right"></div>
      </section>

      {/* Detailed Modules Section */}
      <section className="tf-detailed-modules-section">
        <div className="tf-section-divider">
          <h2 className="tf-section-title-thinkfinance">Available Modules</h2>
        </div>
        
        <div className="tf-modules-grid">
          {/* Module 1 - Profit & Loss */}
          <div className="tf-detailed-module">
            <div className="tf-module-image-container">
              <div className="tf-red-square">
              
                  <svg viewBox="0 0 24 24" width="50%" height="50%" fill="#fff">
                    <path d="M4 20h3v-6h-3v6zm5 0h3V8H9v12zm5 0h3v-9h-3v9zm5 0h3v-3h-3v3z"/>
                  </svg>
              </div>
            </div>
            <h3 className="tf-module-title">Profit & Loss</h3>
            <p className="tf-module-description">
              Track profit margins and drill into transactions behind abnormal costs.
            </p>
          </div>

          {/* Module 2 - Balance Sheet */}
          <div className="tf-detailed-module">
            <div className="tf-module-image-container">
              <div className="tf-red-square">
                <svg viewBox="0 0 24 24" width="40%" height="40%" fill="#fff">
                  <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
                </svg>
              </div>
            </div>
            <h3 className="tf-module-title">Balance Sheet</h3>
            <p className="tf-module-description">
              Access the health of your company through detailed movements of Assets and Liabilities.
            </p>
          </div>

          {/* Module 3 - Cash Flow */}
          <div className="tf-detailed-module">
            <div className="tf-module-image-container">
              <div className="tf-red-square">
                <svg viewBox="0 0 24 24" width="40%" height="40%" fill="#fff">
                  <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                </svg>
              </div>
            </div>
            <h3 className="tf-module-title">Cash Flow</h3>
            <p className="tf-module-description">
              Monitor trend of cash flow activities and analyze efficiency of cash usage.
            </p>
          </div>

          {/* Module 4 - Actual, Budget, Forecast Comparison */}
          <div className="tf-detailed-module">
            <div className="tf-module-image-container">
              <div className="tf-red-square">
                <svg viewBox="0 0 24 24" width="40%" height="40%" fill="#fff">
                  <path d="M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z"/>                </svg>
              </div>
            </div>
            <h3 className="tf-module-title">Actual, Budget, Forecast Comparison</h3>
            <p className="tf-module-description">
              Gives you everything you need to compare across Actual, Budget and Forecast P&Ls, by segments and with trends.
            </p>
          </div>

          {/* Module 5 - P&L Segmentation */}
          <div className="tf-detailed-module">
            <div className="tf-module-image-container">
              <div className="tf-red-square">
                <svg viewBox="0 0 24 24" width="40%" height="40%" fill="#fff">
                  <path d="M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z"/>
                </svg>
              </div>
            </div>
            <h3 className="tf-module-title">P&L Segmentation</h3>
            <p className="tf-module-description">
              Combine your allocation with our AI engine to analyze profitability of Products, Business & Customer segments.
            </p>
          </div>

          {/* Module 6 - P&L Forecasting */}
          <div className="tf-detailed-module">
            <div className="tf-module-image-container">
              <div className="tf-red-square">
                <svg viewBox="0 0 24 24" width="40%" height="40%" fill="#fff">
                <path d="M3 16L8 11 13 14 21 6" stroke="#fff" stroke-width="2" fill="none"/>
                </svg>
              </div>
            </div>
            <h3 className="tf-module-title">P&L Forecasting</h3>
            <p className="tf-module-description">
              Our AI engine generates sales forecasts and cost estimates to give you future state of your P&L.
            </p>
          </div>

          {/* Module 7 - Cost Structure Analyser */}
          <div className="tf-detailed-module">
            <div className="tf-module-image-container">
              <div className="tf-red-square">
                <svg viewBox="0 0 24 24" width="40%" height="40%" fill="#fff">
                  <path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.09-.16-.26-.25-.44-.25-.06 0-.12.01-.17.03l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.06-.02-.12-.03-.18-.03-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.09.16.26.25.44.25.06 0 .12-.01.17-.03l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74s.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/>
                </svg>
              </div>
            </div>
            <h3 className="tf-module-title">Cost Structure Analyser</h3>
            <p className="tf-module-description">
              Allows you to generate a version of your P&L cost groupings structured together, giving you an alternative view to the standard P&L to aid in business planning.
            </p>
          </div>
        </div>
        <div className= "tf-demo-btn-container">
          <button className="tf-demo-btn" onClick={() => handleNavigate('/usecase_finance')}>Learn more about ThinkFinance use cases </button> 
        </div>
        <div className="tf-accent-shape-bottom-right"></div>
      </section>
    </div>
  );
};

export default ThinkFinancePage;